//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    getActInfo
} from '../../api';
import MHeader from '../Header/Header.vue';
import MList from './MList.vue';
export default {
    data() {
        return {
            modeltype: "", // 底部list 排序方式
            data: ""
        }
    },
    components: {
        MHeader,
        MList
    },

    beforeRouteEnter: (to, from, next) => {
        if (from.name == 'detail') {
            next();
        } else {
            let lable_id = to.params.lable_id;
            let modeltype = to.params.modeltype;
            let widgets_type = to.params.widgets_type;
            getActInfo(`widgets_id=${lable_id}&widgets_type=${widgets_type}`).then(res => {
                console.log(res);
                if (res.data.error) {
                    alert(res.data.msg);
                    console.error(res);
                    return;
                };
                setTimeout(function() {
                    next(vm => {
                        vm.modeltype = modeltype;
                        vm.data = res.data.data;
                    });
                }, 300);

            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/HomeTopNav/HomeTopNav.vue